import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
import { ToastProvider } from './providers/ToastProvider';
import { ApiTriggerProvider } from './providers/apiTriggerContext';
import 'react-toastify/dist/ReactToastify.css';
// components
import { StyledChart } from './components/chart';
import ScrollToTop from './components/scroll-to-top';
// css
import './assets/css/style.css';
import TopBarProgress from './utils/TopBarProgress';
// ----------------------------------------------------------------------

export default function App() {

    const isBeta = window.location.href.startsWith('https://beta.');

    return (
        <HelmetProvider>
            <BrowserRouter>
                <ThemeProvider>
                    <ToastProvider>
                    <ApiTriggerProvider>
                    <ScrollToTop />
                    <StyledChart />
                    <ToastContainer position="top-right" pauseOnHover newestOnTop autoClose={300000} />
                    <Helmet>
                        <meta name="robots" content="noindex, nofollow" />
                    </Helmet>
                    <Suspense
                        fallback={
                            <div>
                                <TopBarProgress />
                            </div>
                        }
                    >
                        <Router />
                    </Suspense>
                    </ApiTriggerProvider>
                    </ToastProvider>
                </ThemeProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
}
